// @flow

import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';

import {
    ON_PASSWORD_CHANGED,
    VIRTUAL_KEY_PRESSED,
    PHYSICAL_KEY_PRESSED,
    SUBMIT_VIRTUAL_PASSWORD,
    VALIDATE_PIN
} from './actionTypes';

ReducerRegistry.register('wildix/features/virtual-keyboard', (state = {}, action) => {

    switch (action.type) {

    case VIRTUAL_KEY_PRESSED:
        return {
            ...state,
            keyValue: action.keyValue
        };
    case ON_PASSWORD_CHANGED:
        return {
            ...state,
            password: action.password
        };
    case PHYSICAL_KEY_PRESSED:
        return {
            ...state,
            keyboardEvent: action.keyboardEvent
        };
    case SUBMIT_VIRTUAL_PASSWORD:
        return {
            ...state,
            submitEnabled: action.payload
        };
    case VALIDATE_PIN:
        return {
            ...state,
            pinData: action.pinData
        };
    }

    return state;
});
